import { Http, RequestOptions, Headers } from '@angular/http';
import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/throw';
import 'rxjs/add/observable/of';
import { PORTUGAL_CODE, IS_PORTUGAL,CODE_LANG } from '../helpers/GlobalConstants';

@Injectable()
export class AuthService {

    private accessToken = '';

    constructor(private http: Http) {
    }

    saveInSession(key, value): void {
        //// console.log('recieved = key:' + key + ', value:' + value);
        localStorage.setItem(key, value);
    }

    getFromSession(key): any {
        //// console.log('recieved = key:' + key);
        return localStorage.getItem(key);
    }

    public getAuthorizationUrl(secret, callbackUrl) {
        const uri = environment.oauth.authorize +
                    '?response_type=' + environment.oauth.response_type +
                    '&client_id=' + environment.oauth.client_id +
                    '&scope=' + environment.oauth.scope +
                    '&state=' + secret +
                    '&redirect_uri=' + (typeof callbackUrl === undefined ? environment.oauth.redirectTo : callbackUrl);
        window.location.href = uri;
    }

    getAccessTokenRequest(code) {
        const headers = new Headers({
            'Authorization': 'Basic ' + this.encodeCredentials(environment.oauth.client_id,
                environment.oauth.secret),
            'Content-Type': 'application/x-www-form-urlencoded'
          });
        const options = new RequestOptions({ headers: headers });
        const body = 'client_id=' + environment.oauth.client_id
                + '&grant_type=authorization_code'
                + '&credentials=true'
                + '&code=' + code
                + '&client_secret=' + environment.oauth.secret
                + '&scope=' + environment.oauth.scope
                + '&redirect_uri=' + environment.oauth.redirectTo;
        return this.http.post(environment.oauth.token, body, options)
            .map(response => {
                //// console.log(response);
                return response.json();
            })
            .map(response => {
                if (response.access_token) {
                    //// console.log(response.access_token);
                    localStorage.setItem('access_token', response.access_token);
                  localStorage.setItem('expires_in', btoa((new Date().getTime() +
                    new Date(response.expires_in * 1000).getTime()).toString()));
                  if (response.userProfile) {
                        return response.userProfile;
                    }
                }
                return '';
            });
    }

    encodeCredentials(client_id, client_secret) {
        const credentials = client_id + ':' + client_secret;
        return btoa(credentials);
    }

    getAccessToken(code) {
        if (!this.hasValidAccessToken()) {
            return this.getAccessTokenRequest(code).map(userProfile => {
                console.log('userProfile', userProfile);
                if(userProfile.countryCode == PORTUGAL_CODE){
                    localStorage.setItem(IS_PORTUGAL, 'Y');
                }
                if (userProfile.codeLang) {
                    localStorage.setItem(CODE_LANG,userProfile.codeLang);
                }
                localStorage.setItem(environment.oauth.remoteUser, JSON.stringify(userProfile));
                localStorage.setItem("myAppAccess", JSON.parse(JSON.stringify(userProfile.sectret2FA)));
                return userProfile;
            });
        }
    }

    randomInt(min, max): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    hasValidAccessToken() {
        return this.getFromSession('access_token') !== null;
    }

}



// WEBPACK FOOTER //
// ./src/app/service/AuthService.ts